import { useMemo } from 'react';
import type { EntitySecurity } from '../../../auth/Security';
import { useDataLegacyRowPermissions } from '../../hooks/useDataLegacyRowPermissions';
import { useDataRowPermissions } from '../../hooks/useDataRowPermissions';
import { getDataListActions } from '../getDataListActions';
import type { UseDataListActionsParams } from '../types';

export function useDataListActions({
    item,
    feature,
    entity,
    onEdit,
    onShare,
    onDelete,
    onAttachments,
    onNotes,
    onActivateOrInactivateHandle,
    onCustomAttribute,
    onTagHandle,
    customRowActions = []
}: UseDataListActionsParams) {
    const entitySecurity = item?.security as EntitySecurity | undefined;
    const legacyRowPermissions = useDataLegacyRowPermissions(feature, entitySecurity);
    const centralizedRowPermissions = useDataRowPermissions(entity, entitySecurity);
    const resolvedRowPermissions = entity ? centralizedRowPermissions : legacyRowPermissions;

    return useMemo(
        () =>
            getDataListActions({
                resolvedRowPermissions,
                entityName: entity,
                entitySecurity,
                item,
                onEdit,
                onShare,
                onDelete,
                onAttachments,
                onNotes,
                onActivateOrInactivateHandle,
                onCustomAttribute,
                onTagHandle,
                customRowActions
            }),
        [
            resolvedRowPermissions,
            entity,
            entitySecurity,
            item,
            onEdit,
            onShare,
            onDelete,
            onAttachments,
            onNotes,
            onActivateOrInactivateHandle,
            onCustomAttribute,
            onTagHandle,
            customRowActions
        ]
    );
}
